module.exports = __webpack_public_path__ + "img/ciclos-icon.013723f5.svg";